(() => {
  // Basic configuration of constants used during this script
  const botPattern = '(bot|crawler|spider|crawling|bing|bingbot|google|msnbot|aol|DuckDuckBot|yahoo|ecosia|teoma|rpd|Chrome-Lighthouse|gtmetrix|speedcurve|DareBoost|PTST)';
  const re = new RegExp(botPattern, 'i');
  const userAgent = navigator.userAgent.toLowerCase();
  const cyPattern = '(cypress)';
  const cyReg = new RegExp(cyPattern, 'i');
  const TCF_LISTENER_ID = 2;
  // eslint-disable-next-line camelcase
  const TCF_Data_ID = 2;
  const isGPTProvider = window.provider === 'gpt';
  const isStroeerProvider = window.provider === 'stroeer';
  const isCeleraonePaywall = window.paywallType === 'celeraone';
  const isPaidtimePaywall = window.paywallType === 'paidtime';
  // eslint-disable-next-line
  const browserStorage = window.localStorage;
  const originalReferrer = document.referrer;

  // read certain cookie value
  function getCookie(o) {
    const t = (`; ${document.cookie}`).split(`; ${o}=`);
    let result;
    if (t.length === 2) {
      result = t.pop().split(';').shift();
    }
    return result;
  }
  // check if user is a paid user
  function userIsPaid() {
    let userIsPaid = false;
    const ssoCookie = getCookie('sso');
    if (isCeleraonePaywall && window.dataLayer[0].adFreeReasons.PaidUser === 1) {
      userIsPaid = true;
    } else if (isPaidtimePaywall && ssoCookie) {
      let ssoCookieString = ssoCookie.substring(1, ssoCookie.length - 1);
      ssoCookieString = atob(ssoCookieString);
      const ssoCookieObject = JSON.parse(ssoCookieString);
      userIsPaid = ssoCookieObject && ssoCookieObject.paidtime && ssoCookieObject.paidtime === 1;
    }
    return userIsPaid;
  }

  // delete a certain cookie
  function deleteCookie(name) {
    const path = '/';
    const splitedHostname = window.location.hostname.split('.');
    const domain = `${splitedHostname[splitedHostname.length - 2]}.${splitedHostname[splitedHostname.length - 1]}`;
    if (getCookie(name)) {
      document.cookie = `${name}=${
        (path) ? `;path=${path}` : ''
      }${(domain) ? `;domain=${domain}` : ''
      };expires=Thu, 01 Jan 1970 00:00:01 GMT`;
    }
  }

  // delete consent cookies
  const deleteConsentCookies = () => {
    deleteCookie('eupubconsent-v2');
    deleteCookie('OptanonConsent');
  };

  function isSubdomain(hostname) {
    // eslint-disable-next-line no-useless-escape
    const regex = new RegExp(/^([a-z]+\:\/{2})?([\w-]+\.[\w-]+\.\w+)$/);
    return !!hostname.match(regex);
  }

  function enableScriptTags() {
    const list = document.getElementsByTagName('script');
    // eslint-disable-next-line
    for (const key in list) {
      if (list[key].type === 'text/plain' && list[key].dataset.consent === 'true') {
        list[key].removeAttribute('type');
        list[key].removeAttribute('data-consent');
        document.getElementsByTagName('body')[0].appendChild(list[key]);
      }
    }
  }

  function redirectUser() {
    if (userIsPaid()) {
      deleteConsentCookies();
      return;
    }
    deleteCookie('eupubconsent-v2');
    deleteCookie('OptanonConsent');
    deleteCookie('cPage');

    /* eslint-disable */
    browserStorage.setItem('park.consent.referrer', `${window.location.href}`);
    browserStorage.setItem('park.consent.title', `${consentTitle}`);
    browserStorage.setItem('park.consent.initialReferrer', originalReferrer);
    /*eslint-enable*/

    if (isSubdomain(window.location.hostname)) {
      window.location.href = `${window.consentUrl}?ref=${encodeURIComponent(window.location.href)}`;
    } else {
      window.location.href = window.consentUrl;
    }
  }

  function initHeaderBidder() {
    if (!window.park) {
      console.log('widgets/consent/consent-page.js::initHeaderBidder::window.park not available');
      setTimeout(initHeaderBidder, 500);
      return;
    }
    if (!window.park.headerBidder) {
      console.log('widgets/consent/consent-page.js::initHeaderBidder::window.park.headerBidder not available');
      setTimeout(initHeaderBidder, 500);
      return;
    }
    console.log('widgets/consent/consent-page.js::initHeaderBidder::o.k. > load');
    window.park.headerBidder.loadAndInit();
  }

  function initStroer() {
    if (!window.park) {
      console.log('widgets/consent/consent-page.js::initStroer::window.park not available');
      setTimeout(initStroer, 500);
      return;
    }
    if (!window.park.stroeer) {
      console.log('widgets/consent/consent-page.js::initStroer::window.park.stroeer not available');
      setTimeout(initStroer, 500);
      return;
    }
    if (!window.SDG) {
      console.log('widgets/consent/consent-page.js::initStroer::window.SDG not available');
      setTimeout(initStroer, 500);
      return;
    }
    console.log('widgets/consent/consent-page.js::initStroer::o.k. > init');
    window.park.stroeer.init();
  }

  function startVendorStrategy() {
    console.log('widgets/consent/consent-page.js::startVendorStrategy');
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.defer = true;
    script.onload = () => {
      if (isGPTProvider) {
        console.log('widgets/consent/consent-page.js::startVendorStrategy::initHeaderBidder');
        initHeaderBidder();
        return;
      }
      if (isStroeerProvider) {
        if (isStroeerProvider) {
          const metaTagScript = document.createElement('script');
          metaTagScript.type = 'text/javascript';
          metaTagScript.src = 'https://cdn.stroeerdigitalgroup.de/metatag/live/OMS_wz.de/metaTag.min.js';
          document.getElementsByTagName('head')[0].appendChild(metaTagScript);
        }

        console.log('widgets/consent/consent-page.js::startVendorStrategy::initStroer');
        initStroer();
      }
    };
    script.src = window.slotsSrc;
    console.log(`widgets/consent/consent-page.js::startVendorStrategy::load src > ${window.slotsSrc}`);
    document.getElementsByTagName('head')[0].appendChild(script);
  }

  function tcfDataCallback(tcData, success) {
    console.log('widgets/consent/consent-page.js::tcfDataCallback');
    let consentSize = 0;
    if (success && tcData.cmpStatus === 'loaded') {
      console.log('widgets/consent/consent-page.js::tcfDataCallback::success && tcData.cmpStatus = loaded');
      // eslint-disable-next-line
      for (const purposeConsent in tcData.purpose.consents) {
        if (tcData.purpose.consents[purposeConsent] === false) {
          console.log('widgets/consent/consent-page.js::tcfDataCallback::no consent > redirect 1');
          redirectUser();
          return;
        }
        if (tcData.purpose.consents[purposeConsent] === true) {
          consentSize += 1;
        }
      }
      if (consentSize !== 10) {
        console.log('widgets/consent/consent-page.js::tcfDataCallback::no consent > redirect 2');
        redirectUser();
        return;
      }

      if (!userIsPaid()) {
        startVendorStrategy();
      }
    }
  }

  // TCF API Callback
  // eslint-disable-next-line no-unused-vars
  function tcfEventCallback(tcData, success) {
    console.log('widgets/consent/consent-page.js::tcfEventCallback');
    if (tcData.eventStatus === 'tcloaded') {
      console.log('widgets/consent/consent-page.js::tcfEventCallback > tcloaded');
      // remove listener as it's no longer needed
      // eslint-disable-next-line no-underscore-dangle,no-unused-vars
      window.__tcfapi('removeEventListener', TCF_LISTENER_ID, (success) => {
        console.log(`widgets/consent/consent-page.js::tcfEventCallback > removeEventListener with id: ${tcData.listenerId}`);
      }, tcData.listenerId);
      // retrieve data using getTCData
      // eslint-disable-next-line no-underscore-dangle
      window.__tcfapi('getTCData', TCF_Data_ID, tcfDataCallback);
    }
  }

  // eslint-disable-next-line max-len
  // Wait for window.__tcfapi to be defined, then trigger when the customer has completed their consent and preferences.
  function addTCFListener() {
    console.log('widgets/consent/consent-page.js::addTCFListener');
    // eslint-disable-next-line no-underscore-dangle
    if (window.__tcfapi && document.cookie.indexOf('eupubconsent-v2') >= 0 && window.dataLayer[0].adFreeReasons.PaidUser !== 1) {
      console.log('widgets/consent/consent-page.js::addTCFListener > __tcfapi available > addEventListener');
      // eslint-disable-next-line no-underscore-dangle
      window.__tcfapi('addEventListener', TCF_LISTENER_ID, tcfEventCallback);
      enableScriptTags();
    } else {
      // window.__tcfapi wasn't defined. Check again in 100 milliseconds
      setTimeout(addTCFListener, 100);
    }
  }

  function isSkippable() {
    if (window.location.hostname.indexOf('gera-interred') > -1) {
      return true;
    }
    if (window.location.hostname.indexOf('vorschau-www') > -1) {
      return true;
    }
    // eslint-disable-next-line no-mixed-operators
    if ((re.test(userAgent) || window.navigator.webdriver) && !cyReg.test(userAgent)) {
      return true;
    }
    return false;
  }

  function isBase64(string) {
    let isBase64 = false;
    if (btoa(atob(string)) === string) {
      isBase64 = true;
    }
    return isBase64;
  }

  function isCPageOutdated() {
    let cPageIsOutdated = false;
    const cPageCookie = parseInt(getCookie('cPage'), 10);
    const consentCookieDate = parseInt(window.consentCookieDate, 10);

    if (!!window.consentCookieDate && cPageCookie < consentCookieDate) {
      cPageIsOutdated = true;
    }
    return cPageIsOutdated;
  }

  function whenCreAvailable(name, callback) {
    const interval = 10; // ms
    window.setTimeout(() => {
      if (window[name]) {
        callback(window[name]);
      } else {
        whenCreAvailable(name, callback);
      }
    }, interval);
  }

  function needsRedirect() {
    if ((!getCookie('eupubconsent-v2') || !getCookie('OptanonConsent')) && (!userIsPaid())) {
      return true;
    }
    return false;
  }

  function needsCookieDeletion() {
    if ((getCookie('sso') &&
      getCookie('sso-sid') &&
      getCookie('sso_user') &&
      !getCookie('eupubconsent-v2') &&
      !getCookie('OptanonConsent') &&
      browserStorage.getItem('park.user.npa') === '1') ||
      (browserStorage.getItem('park.user.authenticated') === 'true' && userIsPaid())) {
      return true;
    }
    return false;
  }

  const init = () => {
    if (window.location.href.indexOf('/sso') > -1 || window.location.href.indexOf('/service/login') > -1 || userIsPaid()) {
      console.log('widgets/consent/consent-page.js::init > paying user');
      return;
    }
    const configuredGroups = window.park.exports.config.consentCookieCategoryId.split(',');
    let splitedGroups = [];

    if (isCPageOutdated() || (!(getCookie('cPage')) && (!userIsPaid()))) {
      redirectUser();
      return;
    }
    const activeGroups = getCookie('OptanonConsent').split('&');
    if (activeGroups.length > 0) {
      // eslint-disable-next-line
      for (const cookieEntry in activeGroups) {
        console.log('widgets/consent/consent-page.js::init::check activeGroups');
        if (activeGroups[cookieEntry].indexOf('groups') > -1) {
          activeGroups[cookieEntry] = activeGroups[cookieEntry].replace('groups=', '');
          activeGroups[cookieEntry] = activeGroups[cookieEntry].replace(/%2C/g, '');
          splitedGroups = activeGroups[cookieEntry].split('%3A1');
        }
      }

      // eslint-disable-next-line
      for (const groupId in configuredGroups) {
        if (!splitedGroups.includes(configuredGroups[groupId])) {
          if (!userIsPaid()) {
            redirectUser();
            return;
          }
        }
      }
    }

    addTCFListener();
  };

  if (isBase64(window.consentUrl)) {
    window.consentUrl = atob(window.consentUrl);
  }

  if (originalReferrer.indexOf(window.consentUrl) > -1) {
    Object.defineProperty(document, 'referrer', {
      get: function get() {
        return browserStorage.getItem('park.consent.initialReferrer') || originalReferrer;
      },
    });
  }

  function checkPayWallType() {
    if (isCeleraonePaywall) {
      whenCreAvailable(window.dataLayer[0].adFreeReasons.PaidUser, () => {
        if (needsRedirect()) {
          redirectUser();
          return;
        }
        if (needsCookieDeletion()) {
          deleteConsentCookies();
        }
        // eslint-disable-next-line
        init();
      });
      return;
    }

    if (isPaidtimePaywall) {
      if (needsRedirect()) {
        redirectUser();
        return;
      }
      if (needsCookieDeletion()) {
        deleteConsentCookies();
      }
      // eslint-disable-next-line
      init();
    }
  }
  if (!isSkippable()) {
    checkPayWallType();
  }
})();



// WEBPACK FOOTER //
// ./src/widgets/consent/consent-page.js